import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getBannersApi } from '@flipster/apis/v1/banner';

export const promotionListBunja = bunja(() => {
  const promotionsBaseAtom = atomWithQuery(() => ({
    queryKey: ['getBannersApi', 'REWARD_HUB'],
    queryFn: () => getBannersApi({ image: ['REWARD_HUB'] }),
    select: (res) => res.data.image.REWARD_HUB ?? [],
  }));

  const promotionsAtom = atom((get) => get(promotionsBaseAtom).data ?? []);
  const isPromotionEmptyAtom = atom((get) => get(promotionsAtom).length === 0);
  const isPromotionLoadingAtom = atom((get) => get(promotionsBaseAtom).isLoading);

  return { promotionsAtom, isPromotionEmptyAtom, isPromotionLoadingAtom };
});

promotionListBunja.debugLabel = 'promotionListBunja';
